import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const ShortagesModal = styled.div`
    & ul {
        list-style: none;
        padding: 0;
    }

    & ul li::before {
        content: "•";
        color: ${(props) => props.theme.orange};
        display: inline-block;
        width: 12px;
        margin-left: 0;
    }
`;

export const ClickableShortage = styled.div`
    display: flex;
    align-items: center;
    gap: 9.67px;

    color: ${(props) => props.theme.orange};

    cursor: pointer;

    & span:not(.material-icons-outlined) {
        text-decoration: underline;
    }
`;

export const Container = styled.div`
    padding: 32px 122px;
`;

export const ContentData = styled.div`
    background: ${(props) => props.theme.white};
    padding: 24px;
    border-radius: 16px;
    margin-bottom: 32px;
    border: 1px solid ${(props) => props.theme.borderWhite};

    & .MuiGrid-item {
        display: flex;
        flex-direction: column;

        & label {
            color: ${(props) => props.theme.grey};
        }
        
        & span {
            color: ${(props) => props.theme.black};
            font-size: ${theme.font.size16};
        }
    }
`;

export const Pannel = styled.div`
    display: flex;
    width: 100%;
    border: 1px solid #5B5B5F66;
    border-radius: 16px;
    padding: 24px;
    margin: 0 0 32px 0;
    flex-direction: column;

    & .MuiFormControlLabel-root {
        width: 100%;
    }

    & .MuiTypography-root.MuiFormControlLabel-label{
        width: 100%;
        padding: 0 0 0 24px;
    }

    & .input-checkbox_group{
        gap: 64px 0;
        margin: 0 0 0 10px;

    }
`;
export const ContainerCheckboxLabel = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;

    & > div {
        margin: 0px;
    }

    & .input-info{
        width: 400px ;
    }

    & .input-info_value{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 170px;
        font-size: ${theme.font.size16};

    }   
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 70px;
    padding-top: 10px;
    min-height: 45px;
    margin: 0 0 24px 0;

    & svg {
        color: ${(props) => props.theme.orangeLink};
    }
`;

export const IssuedByWrapper = styled.div`
    width: 220px;
    input, label {
        display:block;
    }
    label {
        color: #5B5B5F;
        font-size: 14px;
    }
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    label {
        margin-right: 20px;
    }
`;

export const IssuedBySelect = styled.select`
    border: none;
    outline: none;
    appearance: none;
    background-color: #f5f5f5;
    cursor: pointer;
`;
